// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"254":"cd7dc0ad","260":"0dcfde98","663":"4c9684bf","856":"eb3ae226"}[chunkId] + ".chunk.css";
};